const SOCKET_EVENTS = {
  ON_SET_BADGE: 'chat.set-badge'
};

window.SocketService = class {
  constructor (socketio) {
    this.isInited = false;
    this.dispatchConnectedInterval = null;
    this.dispatchConnectedIntervalMs = 15000;

    const socketHost = document.documentElement.dataset.socketHost;
    const path = '/api/socket';

    if (typeof socketio === 'undefined' || typeof socketHost === 'undefined') return;

    window.socket = socketio(socketHost, { path });

    this.isInited = true;

    this._initSocketDefaultEvents();
    this._initGlobalEvents();
  }

  on (eventName, callback) {
    if (!this.isInited) return;

    window.socket.on(eventName, params => callback(params));
  }

  emit (eventName, data) {
    if (!this.isInited) return;

    window.socket.emit(eventName, data);
  }

  _initSocketDefaultEvents () {
    // Used to ship carrier's coordinates
    this.on('connect', () => {
      const dispatchConnected = () => {
        window.dispatchEvent(new CustomEvent('socket.connected'));
      }
      dispatchConnected();

      this.dispatchConnectedInterval = setInterval(
        dispatchConnected,
        this.dispatchConnectedIntervalMs
      );
    });
    this.on('disconnect', () => clearInterval(this.dispatchConnectedInterval));
  }

  _initGlobalEvents () {
    /*
    * Called when user send a chat message.
    * Sets messages count of badges or clear it, depends on user's actions
    */
    this.on(SOCKET_EVENTS.ON_SET_BADGE, ({ transferId, clearBadge }) => {
      if (!$('.chat-badge').length) return;

      const dataTransferId = `data-transfer-id="${transferId}"`;
      const $chatBadge = $(`.chat-badge[${dataTransferId}]`);
      const isChatOpen = $(`.chat-modal.in[${dataTransferId}]`).length;
      let messagesCount = $chatBadge.text() ? Number($chatBadge[0].textContent) : 0;

      if (clearBadge || isChatOpen) {
        messagesCount = '';
      } else {
        messagesCount += 1;
      }

      $chatBadge.text(messagesCount);
    });
  }
}
